import { API_PARAM_TYPE, ApiParams } from '@ddt-web/domain';

export class ApiParamConfig {
	// important note, please read before editing or adding any new config
	// please do not set a parameter includeChildren as true when using this together with any rc
	// when rc is provided, api has no fall back for any error/invalid rc, thus it will be by default get all the data
	// with includeChildren = true, this can result in heavy data loading and possibly timeout the request
	// please put includeChildren = true only in rc if needed
	public static readonly ApiParamsList: { [serviceId: string]: ApiParams[] } = {
		APP_COMPONENT_GET_CUSTOMIZED_PORTFOLIO: [
			{ paramId: 'filter', value: '-flags_assetClassPort:true', type: API_PARAM_TYPE.IDENTIFIER.PARAM },
			{ paramId: 'includeChildren', value: 'false', type: API_PARAM_TYPE.IDENTIFIER.PARAM }
		],
		FILTER_PORTFOLIOS_WITH_CHILDREN: [
			{ paramId: 'filter', value: '-flags_containsChildrenPortfolios:true', type: API_PARAM_TYPE.IDENTIFIER.PARAM }
		]
	};
}
